import Box from "@mui/material/Box";
import { Grid, Typography, Paper, Divider } from "@mui/material";
import React from "react";
import { isMobile } from "react-device-detect";
import { readAnswers } from "../../utils/dynamicForm";

// Read-only view of a dynamic (FormBuilder) form's answers on a submitted request.
const DynamicDetailsForm = ({ generalServices }) => {
  const rows = readAnswers(generalServices?.additionalData);
  const title = generalServices?.formName || "تفاصيل الطلب";

  return (
    <>
      <Box
        sx={{
          background: "#fff",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 1.5,
          px: 3,
          width: isMobile ? "100%" : 300,
          borderRadius: "8px",
          border: "2px solid",
          borderColor: "primary.main",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "primary.main" }}>
          {title}
        </Typography>
      </Box>
      <Paper elevation={1} sx={{ p: 3, borderRadius: "12px", border: "1px solid #e0e0e0" }}>
        <Grid container spacing={3}>
          {rows.length === 0 && (
            <Grid item xs={12}>
              <Typography>-</Typography>
            </Grid>
          )}
          {rows.map((row, index) =>
            row.type === "header" || row.type === "paragraph" ? (
              <Grid item xs={12} key={index}>
                <Typography
                  sx={{ fontWeight: row.type === "header" ? "bold" : "normal", color: row.type === "header" ? "primary.main" : "inherit", whiteSpace: "pre-line" }}
                >
                  {row.label}
                </Typography>
              </Grid>
            ) : (
              <Grid item xs={12} md={row.type === "textarea" ? 12 : 6} key={index}>
                <Typography sx={{ fontWeight: "bold", mb: 1 }}>{row.label}:</Typography>
                <Typography
                  component="div"
                  sx={{
                    p: 2,
                    border: "1px solid #e0e0e0",
                    borderRadius: "4px",
                    backgroundColor: "#f5f5f5",
                    minHeight: "56px",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                  }}
                >
                  {row.answers.length ? row.answers.join("، ") : "-"}
                </Typography>
              </Grid>
            )
          )}
        </Grid>
      </Paper>
      <Divider />
    </>
  );
};

export default DynamicDetailsForm;
